import React, { useState, useEffect } from "react";
import { Col, Row, Card, Form, Button, Alert } from '@themesberg/react-bootstrap';
import api from '../../utils/api';
import { useHistory, useParams } from 'react-router-dom';

export default () => {
  const history = useHistory();
  const { id } = useParams();
  const isEditMode = !!id;
  const [formData, setFormData] = useState({
    packageName: "",
    price: "",
    sku: "",
    days: "",
    order: "0",
    visible: true
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loadingData, setLoadingData] = useState(isEditMode);

  // Edit modunda paket verilerini yükle
  useEffect(() => {
    if (isEditMode && id) {
      loadPackageData();
    }
  }, [id, isEditMode]);

  const loadPackageData = async () => {
    try {
      setLoadingData(true);
      const response = await api.get(`/packages/vip/${id}`);
      const data = response.data?.package
        || (Array.isArray(response.data?.packages)
          ? response.data.packages.find(p => p.id === id || p._id === id)
          : null)
        || (Array.isArray(response.data)
          ? response.data.find(p => p.id === id || p._id === id)
          : null);
      if (data) {
        setFormData({
          packageName: data.packageName || "",
          price: data.price?.toString() || "",
          sku: data.sku || "",
          days: data.days?.toString() || "",
          order: data.order?.toString() || "0",
          visible: data.visible !== undefined ? data.visible : true
        });
      } else {
        setError("Paket bulunamadı.");
      }
    } catch (err) {
      console.error("Error loading package:", err);
      setError("Paket yüklenirken hata oluştu: " + err.message);
    } finally {
      setLoadingData(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    if (error) setError(null);
  };

  // Form geçerliliğini kontrol et
  const isFormValid = () => {
    return formData.packageName.trim() !== '' &&
      formData.price.trim() !== '' &&
      formData.sku.trim() !== '' &&
      formData.days.trim() !== '' &&
      !loading;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      // Sıra değerini number'a çevir
      const orderValue = parseInt(formData.order) || 0;
      if (orderValue < 0 || orderValue > 100) {
        setError("Sıra değeri 0-100 arasında olmalıdır.");
        setLoading(false);
        return;
      }

      // Gün değerini number'a çevir
      const days = parseInt(formData.days) || 0;
      if (days <= 0) {
        setError("Gün değeri 0'dan büyük olmalıdır.");
        setLoading(false);
        return;
      }

      // Fiyat kontrolü - Türkçe formatı (virgül) destekle
      const priceString = formData.price.toString().replace(',', '.');
      const price = parseFloat(priceString) || 0;
      if (price <= 0) {
        setError("Fiyat 0'dan büyük olmalıdır.");
        setLoading(false);
        return;
      }

      // SKU kontrolü
      if (!formData.sku || formData.sku.trim() === '') {
        setError("SKU alanı zorunludur.");
        setLoading(false);
        return;
      }

      // Paket adı kontrolü
      if (!formData.packageName || formData.packageName.trim() === '') {
        setError("Paket adı zorunludur.");
        setLoading(false);
        return;
      }

      // Firebase'e kaydet
      const packageData = {
        packageName: formData.packageName.trim(),
        price: price,
        sku: formData.sku.trim(),
        days: days,
        order: orderValue,
        visible: formData.visible
      };

      if (isEditMode) {
        packageData.updatedAt = new Date();
        await api.put(`/packages/vip/${id}`, packageData);
      } else {
        packageData.createdAt = new Date();
        await api.post('/packages/vip', packageData);
      }

      setSuccess(true);
      setTimeout(() => {
        // Eğer VipPackages sayfasındaysak (tab içindeysek), tab'ı değiştir
        if (window.location.pathname === '/packages/vip') {
          window.dispatchEvent(new CustomEvent('switchToTab', { detail: 'list' }));
        } else {
          history.push('/packages/vip/list');
        }
      }, 1500);
    } catch (err) {
      console.error("Error adding VIP package:", err);
      let errorMessage = "Paket eklenirken bir hata oluştu.";
      if (err.code === 'permission-denied') {
        errorMessage = "Firestore izin hatası. Lütfen Firebase Console'da güvenlik kurallarını kontrol edin.";
      } else if (err.message) {
        errorMessage = `Hata: ${err.message}`;
      }
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  if (loadingData) {
    return (
      <>
        <div className="py-4">
          <h4>{isEditMode ? "VIP Paketi Düzenle" : "VIP Paketi Ekle"}</h4>
        </div>
        <Card className="border-0 shadow-sm mb-4">
          <Card.Body className="text-center p-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Yükleniyor...</span>
            </div>
            <p className="mt-3">Paket bilgileri yükleniyor...</p>
          </Card.Body>
        </Card>
      </>
    );
  }

  return (
    <>
      <div className="py-4">
        <h4>{isEditMode ? "VIP Paketi Düzenle" : "VIP Paketi Ekle"}</h4>
      </div>

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError(null)}>
          {error}
        </Alert>
      )}
      {success && (
        <Alert variant="success">
          VIP paket {isEditMode ? "başarıyla güncellendi" : "başarıyla eklendi"}! Yönlendiriliyorsunuz...
        </Alert>
      )}

      <Card className="border-0 shadow-sm mb-4">
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>
                    Paket Adı <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="packageName"
                    placeholder="Paket Adı"
                    value={formData.packageName}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>
                    Fiyat <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="price"
                    placeholder="55.99"
                    value={formData.price}
                    onChange={handleChange}
                    required
                  />
                  <Form.Text className="text-muted">
                    Fiyat formatı: 199.99 veya 199,99 (TL)
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>
                    SKU <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="sku"
                    placeholder="SKU"
                    value={formData.sku}
                    onChange={handleChange}
                    required
                  />
                  <Form.Text className="text-muted">
                    Google Play Console'daki Product ID ile tam eşleşmeli (örn: 1haftalıkvip)
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>
                    Gün <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="days"
                    placeholder="1"
                    value={formData.days}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>Sıra</Form.Label>
                  <Form.Control
                    type="number"
                    name="order"
                    placeholder="0"
                    min="0"
                    max="100"
                    value={formData.order}
                    onChange={handleChange}
                  />
                  <Form.Text className="text-muted">
                    En küçük sıra numarasına sahip paket listenin en başında gözükecek (0-100 arası)
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>Görünürlük</Form.Label>
                  <div className="d-flex align-items-center">
                    <Form.Check
                      type="switch"
                      id="visible-switch"
                      name="visible"
                      checked={formData.visible}
                      onChange={handleChange}
                      label="Herkese Açık"
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-end">
              <Button
                variant="primary"
                type="submit"
                size="lg"
                disabled={!isFormValid()}
              >
                {loading ? (isEditMode ? "Güncelleniyor..." : "Ekleniyor...") : (isEditMode ? "Güncelle" : "Ekle")}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};
